module.exports = __webpack_public_path__ + "img/组 18.80042be3.png";